module.exports = __webpack_public_path__ + "media/klaseaDia3K42Vert.75f57864.mp4";